<template>
  <a-modal
    v-model="visible"
    :title="modalTitle"
    :maskClosable="false"
    forceRender
    destroyOnClose
    :bodyStyle="{ padding: 0 }"
    centered
    :afterClose="cancel"
    wrapClassName="g-modal-webui"
  >
    <Loading :show="true" v-if="checkLoading" style="margin:30px auto;" />
    <div v-else class="webui-content">
      <div v-if="webuiInfo || sshInfo">
        <!-- 有URL -->
        <div v-if="webuiInfo" class="webui-link">
          <ul>
            <li v-if="webuiInfo">
              <label>{{ $t('device_vpn_url_label') }}：</label>
              <div>
                <a :href="`${WEBUIDomain}`" target="_blank">
                  {{ WEBUIDomain }}
                </a>
                <a-button
                  type="default"
                  @click="copyContent('#CopyURL')"
                  :data-clipboard-text="`${WEBUIDomain}`"
                  data-clipboard-action="copy"
                  id="CopyURL"
                  size="small"
                >
                  {{ $t('com_btn_copy') }}
                </a-button>
              </div>
            </li>
            <li>
              <label>{{ $t('device_vpn_dynamic_password') }}:</label>
              <div>
                <span>{{ webuiInfo.pwd }}</span>
                <a-button
                  type="default"
                  @click="copyContent('#CopyPassword')"
                  :data-clipboard-text="webuiInfo.pwd"
                  data-clipboard-action="copy"
                  id="CopyPassword"
                  size="small"
                >
                  {{ $t('com_btn_copy') }}
                </a-button>
              </div>
            </li>
            <li>
              <label>{{ $t('device_vpn_remaining_time') }}:</label>
              <span
                class="webui-link-expired"
                ref="expiredTime"
                v-if="webuiInfo && webuiInfo.restPeriod"
              >
                {{ formatSeconds(webuiInfo.restPeriod) }}
              </span>
              <span v-else> {{ formatSeconds(webuiInfo.restPeriod) }} </span>
            </li>
          </ul>
        </div>

        <!-- SSH -->
        <div v-if="sshInfo && deviceInfo" class="webui-link">
          <ul>
            <li>
              <label>{{ $t('device_vpn_remaining_time') }}:</label>
              <span class="webui-link-expired" ref="expiredTime" v-if="sshInfo.restPeriod">
                {{ formatSeconds(sshInfo.restPeriod) }}
              </span>
              <span v-else> {{ formatSeconds(webuiInfo.restPeriod) }} </span>
            </li>
          </ul>
        </div>
      </div>

      <a-form-model
        :model="form"
        :rules="rules"
        ref="formElement"
        :label-col="{ span: 7 }"
        :wrapper-col="{ span: 14 }"
        v-else
      >
        <!-- 有效时间 -->
        <a-form-model-item :label="$t('device_vpn_period')" prop="period">
          <a-select
            v-model="form.period"
            show-search
            :placeholder="$t('device_vpn_period_placeholder')"
            style="width:170px"
            :filter-option="filterOption"
            :disabled="formLoading"
          >
            <a-select-option v-for="time in expiredList" :key="time" :value="time">
              {{ `${time}${$t('com_time_min')}(${time / 60}${$t('com_time_hour')})` }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
    </div>

    <template #footer>
      <div class="webui-footer" v-if="!checkLoading">
        <!-- 错误描述 -->
        <div class="form-error-text">
          <Icon type="error" v-if="formError" />
          <p>{{ formError }}</p>
        </div>
        <div v-if="webuiInfo || sshInfo">
          <a-button
            type="danger"
            @click="destoryWEBUI"
            icon="delete"
            :loading="destoryLoading"
            style="margin-left:16px;"
            v-if="webuiInfo"
            v-auth="['auth_device_webui_disconnect']"
          >
            {{ $t('device_vpn_destroy_url') }}
          </a-button>

          <a :href="`${SSHDomain}`" target="_blank" v-if="sshInfo">
            <a-button type="primary">
              {{ $t('device_vpn_open_ssh') }}
            </a-button>
          </a>

          <a-button
            type="danger"
            @click="destorySSHLink"
            icon="delete"
            :loading="destoryLoading"
            style="margin-left:16px;"
            v-if="sshInfo"
          >
            {{ $t('device_vpn_destroy_ssh') }}
          </a-button>
        </div>
        <div v-else>
          <a-button key="submit" type="primary" :loading="formLoading" @click="formSubmit">
            {{ $t('com_btn_create') }}
          </a-button>
        </div>
      </div>
    </template>
  </a-modal>
</template>
<script>
// mixins
import vpnMixin from '@/mixins/vpn';
import { copyContent, formatSeconds } from '@/libs/utils';
import Config from '@/config';
import { mapState } from 'vuex';
import deviceAuth from '@/views/device/mixins/deviceAuth';
import { encryptAES } from '@/libs/crypto';

export default {
  mixins: [vpnMixin, deviceAuth],
  props: ['device', 'deviceStatus', 'deviceStatusFn', 'callback'],
  computed: {
    ...mapState(['userInfo']),
    // WEBUI URL
    WEBUIDomain() {
      const id = this.webuiInfo?.url ? this.webuiInfo.url.split('.')[0] : '';
      return `${this.domainPrototype}//${id}.${process.env?.VUE_APP_WEBUI_DOMAIN || ''}`;
    },

    // SSH URL
    SSHDomain() {
      const tokenStr = this.userInfo?.tokenId;

      // 取token的后128位做为key(SSH后台也是取这个key)
      const key = tokenStr.slice(-128); // 这个128不能乱动，需与SSH后端保持一致
      // 取token的前16个做为iv(SSH后台也是取这个iv)
      const vi = tokenStr.substring(0, 16); // 这个16不能乱动，需与SSH后端保持一致
      // 取两个0-tokenStr.length之间的一个随机区间,长度为50
      const randomStart = Math.floor(Math.random() * (tokenStr.length - 50));
      const randomEnd = randomStart + 50;
      const randomStr = `${tokenStr.slice(randomStart, randomEnd)}`;

      // 通过AES对称加密token
      const tokenCryptStr = encryptAES(key, vi, randomStr);
      // console.log('key', key);
      // console.log('vi', vi);
      // console.log('randomStr', randomStr);
      // console.log('tokenCryptStr', tokenCryptStr);
      // console.log('tokenCryptStrbase64', window.btoa(tokenCryptStr));

      return `${process.env?.VUE_APP_SSH_DOMAIN || ''}?host=${this.sshInfo.ip}&dhost=${
        this.sshInfo.outsideIp
      }&port=${this.sshInfo.port}&start=${randomStart}&end=${randomEnd}&token=${window.btoa(
        tokenCryptStr
      )}&uuid=${this.userInfo?.user.userId}&id=${this.deviceInfo.devId}&name=${encodeURIComponent(
        this.deviceInfo.name || ''
      )}`;
    },

    modalTitle() {
      if (this.vpnType === 'ssh') {
        if (this.sshInfo) {
          return this.$t('device_vpn_ssh_connect_title');
        }
        return this.$t('device_vpn_ssh_create_title');
      } else {
        if (this.webuiInfo) {
          return this.$t('device_vpn_webui_connect_title');
        }
        return this.$t('device_vpn_webui_create_title');
      }
    },
  },
  data() {
    return {
      Config,
      copyContent,
      formatSeconds,
      domainPrototype: 'http:' || window.location.protocol,
      // 可选时间（单位分钟）
      expiredList: [30, 60],

      // 新增
      visible: false,
      rules: {
        period: [
          {
            required: true,
            message: this.$t('device_vpn_period_required_msg'),
            trigger: 'change',
          },
        ],
      },

      // 表单
      form: {
        period: undefined,
      },

      formError: '',
      formType: '',
      formLoading: false,

      // webui
      URL: null,

      // device info
      deviceInfo: null,
    };
  },
  methods: {
    // 父模型过滤
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    //  - 显示
    show(device, type) {
      this.visible = true;
      this.deviceInfo = device;
      this.vpnType = type;

      this.checkVPNFisrt();

      // 重置
      this.formError = null;
      // 默认30分钟
      this.form.period = 30;

      // 1分钟后自动关闭（3期增加需求）
      this.waitToCloseTimer = setTimeout(() => {
        this.cancel();
      }, 60 * 1000);
    },

    //  - 提交
    formSubmit() {
      if (this.URL) {
        this.visible = false;
        return;
      }

      this.$refs.formElement.validate(valid => {
        if (valid) {
          this.formError = '';
          this.formLoading = true;
          this.checkVPNStatus();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    // webui connect callback
    vpnCallback(message) {
      if (message) {
        this.formError = message;
      }
      this.formLoading = false;
    },

    //  - error reset
    formInput() {
      this.formError = '';
    },
    //  - add form reset
    formReset() {
      this.form = {
        period: undefined,
      };
      this.visible = false;
    },

    // 关闭
    cancel() {
      if (this.stopWaitToCloseTimer) {
        this.stopWaitToCloseTimer();

        // 调用一次status/all
        if (this.$parent.deviceStatusFn && typeof this.$parent.deviceStatusFn === 'function') {
          this.$parent.deviceStatusFn();
        }
      }
      this.formError = '';
      this.formLoading = false;
      this.checkLoading = false;
      this.visible = false;
    },
  },
};
</script>
<style lang="less" scoped>
.form-error-text {
  height: 25px;
  line-height: 25px;
  color: #f00;
  display: flex;
  align-items: center;

  p {
    margin: 0 0 0 10px;
    padding: 0;
  }
}

::v-deep .ant-form-item {
  margin-bottom: 10px;
}

.webui-content {
  padding: 30px 20px 20px;
}

.webui-link {
  ul {
    padding: 0;
    margin: 0;

    li {
      padding: 10px 0;
      display: flex;
      align-items: center;
      gap: 10px;

      label {
        color: #999;
        padding-right: 10px;
        text-align: right;
        white-space: nowrap;
      }

      div {
        display: flex;
        gap: 5px;
        align-items: center;
        flex: 1;

        a {
          word-break: break-all;
          word-wrap: break-word;
        }
      }

      span {
        i {
          color: #f00;
          font-style: normal;
        }
      }
    }
  }
}

.webui-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;

  button {
    margin-left: 15px;
  }
}
</style>
